import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const ubicacionImporterSelectors = importerSelectors(
  'ubicacion.importer',
);

export default ubicacionImporterSelectors;
